export default function loadData() {
  //上拉刷新
  let totalHeight = 0;
  let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;//页面卷起的高度
  let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;//可见区域高度
  let documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;//文档高度
  totalHeight = windowHeight + scrollHeight;//页面可见高度+页面卷起的高度
  if (documentHeight - 10 < totalHeight) {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/pullUpdate.js